(() => {
  // app/scripts/pagination-component.js
  var PaginationComponent = class extends HTMLElement {
    constructor() {
      super();
      this.callbacks = [];
      this.init();
    }
    init() {
      const paginationItems = this.querySelectorAll(".js-pagination-item");
      const shopifySection = this.closest('[id^="shopify-section-"]');
      const scrollTarget = shopifySection || document.querySelector("#main-collection");
      const hasFilterComponent = this.closest("filter-component");
      paginationItems.forEach((item) => {
        item.addEventListener("click", (event) => {
          if (this.callbacks.length > 0) {
            event.preventDefault();
            event.stopPropagation();
            this.callbacks.forEach((callback) => callback(item.dataset.page));
            if (!hasFilterComponent && scrollTarget) {
              scrollTarget.scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
            }
          }
        });
      });
    }
    onChange(callback) {
      this.callbacks.push(callback);
    }
    updateLayout(newPagination) {
      this.innerHTML = newPagination.innerHTML;
      this.init();
    }
  };
  if (!customElements.get("pagination-component")) {
    customElements.define("pagination-component", PaginationComponent);
  }
})();
